export default "__VITE_PUBLIC_ASSET__bbdbe678__"